import { createContext, useContext, useState, useEffect } from "react";
import api from "../api/axios";

const Ctx = createContext();
export const useAuth = () => useContext(Ctx);

// Admin uses sessionStorage (tab-only, cleared on tab close, new tab = login required)
// Teacher/student uses localStorage (persists across tabs and browser restarts)
const getToken = () => {
  try { return sessionStorage.getItem("token") || localStorage.getItem("token") || null; }
  catch { return null; }
};
const getUser = () => {
  try { return JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user") || "null"); }
  catch { return null; }
};

export function AuthProvider({ children }) {
  const [user,  setUser]  = useState(getUser);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (token) {
      const timeout = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("auth_timeout")), 5000)
      );
      Promise.race([api.get("/auth/me"), timeout])
        .then(r => {
          const { success: _s, ...userData } = r.data;
          setUser(userData);
          if (userData.role === "admin") {
            // Migrate old localStorage admin token to sessionStorage
            // Only if token came from localStorage (no sessionStorage token exists yet)
            if (!sessionStorage.getItem("token")) {
              const lsToken = localStorage.getItem("token");
              if (lsToken) {
                sessionStorage.setItem("token", lsToken);
                localStorage.removeItem("token");
                localStorage.removeItem("user");
              }
            }
            sessionStorage.setItem("user", JSON.stringify(userData));
          } else {
            localStorage.setItem("user", JSON.stringify(userData));
          }
        })
        .catch(() => {
          sessionStorage.removeItem("token"); sessionStorage.removeItem("user");
          localStorage.removeItem("token");  localStorage.removeItem("user");
          setUser(null);
        })
        .finally(() => setReady(true));
    } else { setReady(true); }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const adminLogin = (token, userData) => {
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    sessionStorage.removeItem("token"); sessionStorage.removeItem("user");
    localStorage.removeItem("token");  localStorage.removeItem("user");
    setUser(null);
  };

  return <Ctx.Provider value={{ user, ready, login, adminLogin, logout }}>{ready && children}</Ctx.Provider>;
}